import React, { useState } from "react";
import { Link } from "@reach/router";
import { auth } from "../firebase";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from "@mui/material";
import { ChildCare } from "@material-ui/icons";
import { palette } from "../theme";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitting(true);
    auth
      .signInWithEmailAndPassword(email, password)
      .catch((err) => {
        setError("Couldn't sign in — check your email and password.");
        console.error("Error signing in with password and email", err);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Box sx={{ px: 2, py: { xs: 4, md: 8 }, display: "flex", justifyContent: "center" }}>
      <Card sx={{ width: "100%", maxWidth: 440 }}>
        <CardContent sx={{ p: { xs: 3, md: 4 } }}>
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                mx: "auto",
                mb: 2,
                borderRadius: "16px",
                background: `linear-gradient(135deg, ${palette.primary}, ${palette.primaryLight})`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
              }}
            >
              <ChildCare style={{ fontSize: 32 }} />
            </Box>
            <Typography variant="h4">Welcome back</Typography>
            <Typography variant="body2" sx={{ color: palette.textSecondary, mt: 0.5 }}>
              Sign in to manage your kids and sessions
            </Typography>
          </Box>

          {error !== null && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
              <TextField
                required
                fullWidth
                type="email"
                label="Email Address"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                required
                fullWidth
                type="password"
                label="Password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button
                type="submit"
                fullWidth
                size="large"
                variant="contained"
                color="secondary"
                disabled={submitting}
              >
                {submitting ? "Signing in..." : "Sign In"}
              </Button>
            </Box>
          </form>

          <Typography variant="body2" sx={{ textAlign: "center", mt: 3 }}>
            <Link to="passwordReset" style={{ fontWeight: 700 }}>
              Forgot your password?
            </Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SignIn;
